import React from 'react'
import HomeGridAndCarouselBase from './HomeGridAndCarouselBase';
import localization from '../../config/localization';

const HomeCarouselElement = (props) => <HomeGridAndCarouselBase
  {...props}
  elementTitle={localization.get('home_editor.carousel_element')}
/>

export default HomeCarouselElement